<template>

    <div class="mt-4 shop::website-modules-shopProducts-show-ProductVariantSelector">

        <div class="text-gray-700">
            <span
                v-if="productIsInStock && selectedAttributeValuesVariantExists('is_in_stock_supplier')"
                class="flex items-center gap-2 my-4"
            >
                <span class="w-3 h-3 rounded-full bg-palette-orange"></span> In voorraad bij leverancier
            </span>
            <span
                v-else-if="productIsInStock && (selectedAttributeValuesVariantExists('is_in_stock') || selectedAttributeValuesEqualsInitial())"
                class="flex items-center gap-2 my-4"
            >
                <span class="w-3 h-3 rounded-full bg-palette-green"></span> In voorraad
            </span>
            <span
                v-else-if="productIsInStock && selectedAttributeValuesEqualsInitial(false)"
                class="flex items-center gap-2 my-4"
            >
                <span class="w-3 h-3 bg-red-400 rounded-full"></span> Niet beschikbaar
            </span>
            <span v-else class="flex items-center gap-2 my-4">
                <span class="w-3 h-3 bg-red-400 rounded-full"></span> Niet in voorraad
            </span>
        </div>

        <div v-for="shopProductAttribute in shopProductAttributes"
             class="flex flex-wrap items-baseline mb-6"
        >

            <div class="w-full mb-3 text-sm font-bold">
                {{ shopProductAttribute.name[language] }}
            </div>

            <div class="flex flex-wrap w-full gap-3">

                <label v-for="attributeValue in shopProductAttribute.attributeValues"
                       class="border border-gray-400 min-w-[6rem] cursor-pointer rounded-md p-3 mb-0 flex items-center justify-center text-sm font-medium focus:outline-none"
                       :class="{
                            'cursor-pointer': productVariantExistsForAttributeValue[shopProductAttribute.id].indexOf(attributeValue) !== -1,

                            'bg-white text-black border-black hover:bg-gray-100': (selectedAttributeValues[shopProductAttribute.id] !== attributeValue),
                            'bg-palette-primary border-palette-primary text-white':
                                (
                                    selectedAttributeValues[shopProductAttribute.id] === attributeValue
                                    && selectedAttributeValuesVariantExists()
                                    && selectedAttributeValuesEqualsInitial(false)
                                ) || (
                                    initialSelectedAttributeValues[shopProductAttribute.id] === attributeValue
                                    && selectedAttributeValuesEqualsInitial()
                                ),
                            'bg-gray-400 text-white border-gray-400': selectedAttributeValues[shopProductAttribute.id] === attributeValue
                                && selectedAttributeValuesEqualsInitial(false),
                            // || (
                            //     selectedAttributeValues[shopProductAttribute.id] === attributeValue &&
                            //     initialSelectedAttributeValues[shopProductAttribute.id] !== selectedAttributeValues[shopProductAttribute.id]
                            // ),
                        }"
                       :title="productVariantExistsForAttributeValue[shopProductAttribute.id].indexOf(attributeValue) === -1
                            ? 'Deze variant is niet beschikbaar met de huidige selectie'
                            : ''
                        "
                       :dusk="(shopProductAttribute.name[language].replace(' ', '_') + '-' + attributeValue.replace(' ', '_')).toLowerCase()"
                >

                    <input type="radio"
                           class="sr-only"
                           v-model="selectedAttributeValues[shopProductAttribute.id]"
                           :name="selectedAttributeValues[shopProductAttribute.id]"
                           :value="attributeValue"
                    >

                    <span class="text-sm">
                      {{ attributeValue }}
                    </span>

                </label>

            </div>

        </div>

        <div class="flex mt-8 sm:flex-col1" v-if="productIsInStock">

            <div
                class="flex px-4 py-2 mr-6 font-normal text-center rounded-md numberInput bg-gray-50 w-36"
            >
                <button
                    class="flex-shrink-0 mr-2 minus"
                    :class="{
                        'text-gray-400': JSON.stringify(initialSelectedAttributeValues) !== JSON.stringify(selectedAttributeValues)
                    }"
                    onclick="this.parentNode.querySelector('input[type=number]').stepDown()"
                    :disabled="JSON.stringify(initialSelectedAttributeValues) !== JSON.stringify(selectedAttributeValues)"
                >
                    <i class="fal fa-minus"></i>
                </button>
                <input
                    class="flex-1 w-full text-center bg-transparent border-none appearance-none"
                    :class="{
                        'text-gray-400': JSON.stringify(initialSelectedAttributeValues) !== JSON.stringify(selectedAttributeValues)
                    }"
                    type="number"
                    name="amount"
                    min="1"
                    value="1"
                    placeholder="Aantal"
                    :disabled="JSON.stringify(initialSelectedAttributeValues) !== JSON.stringify(selectedAttributeValues)"
                />
                <button
                    class="flex-shrink-0 ml-2 plus"
                    :class="{
                        'text-gray-400': JSON.stringify(initialSelectedAttributeValues) !== JSON.stringify(selectedAttributeValues)
                    }"
                    onclick="this.parentNode.querySelector('input[type=number]').stepUp()"
                    :disabled="JSON.stringify(initialSelectedAttributeValues) !== JSON.stringify(selectedAttributeValues)"
                >
                    <i class="fal fa-plus"></i>
                </button>
            </div>

            <button
                name="addToCart"
                dusk="add_to_cart"
                class="flex items-center justify-center flex-1 max-w-xs px-8 py-3 text-base text-white rounded-md focus:outline-none"
                :class="{
                    'bg-gray-400': !selectedAttributeValuesVariantExists('is_in_stock')
                        && selectedAttributeValuesEqualsInitial(false),
                    'opacity-75': selectedAttributeValuesVariantExists('is_in_stock')
                        && selectedAttributeValuesEqualsInitial(false),
                    'bg-palette-green hover:bg-palette-darkgreen': selectedAttributeValuesVariantExists('is_in_stock')
                        || selectedAttributeValuesEqualsInitial(),
                }"
                :disabled="(!selectedAttributeValuesVariantExists('is_in_stock') && !selectedAttributeValuesVariantExists('is_in_stock_supplier')) || selectedAttributeValuesEqualsInitial(false)"
            >
                <div class="shop::website-modules-shopProducts-Checkmark">
                    <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                        <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
                        <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                    </svg>
                </div>

                <span class="hidden md:inline">
                   In winkelwagen
                </span>

                <span class="absolute hidden transform -translate-x-1/2 left-1/2 clickLoad">
                    <svg class="w-5 h-5 text-white animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                </span>

                <span class="inline md:hidden">
                    <img src="/img/website/cart.svg" alt="winkelwagen">
                </span>
            </button>

        </div>

    </div>

</template>

<style lang="scss" scoped>

.shop\:\:website-modules-shopProducts-show-ProductVariantSelector {
    .not-available {
        background: linear-gradient(to bottom right, transparent, transparent 49%, #a3a3a3 51%, transparent 52%, transparent);
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>

<script>

// TODO Medium: Support product variants which are missing a product attribute (in comparison to others), by adding a 'fake' "Geen" attribute value?
export default {

    props: {
        productVariants: String, // Object
        currentProductVariantId: {
            type: Number,
            required: true,
        },
        productVariantBaseUrl: {
            type: String,
            required: true,
        },
        productIsInStock: Boolean,
        language: String,

        discountSlug: String,
        discountPercentage: Number,
    },

    data()
    {
        return {
            productVariantsLocal: JSON.parse(this.$options.propsData.productVariants),
            initialSelectedAttributeValues: {},
            selectedAttributeValues: {},
        };
    },

    mounted()
    {
        this.initSelectedAttributeValues('initialSelectedAttributeValues');
        this.initSelectedAttributeValues('selectedAttributeValues');
    },

    methods: {

        selectedAttributeValuesEqualsInitial(doesEqual = true)
        {
            if(!doesEqual) {
                return JSON.stringify(this.initialSelectedAttributeValues) !== JSON.stringify(this.selectedAttributeValues);
            }

            return JSON.stringify(this.initialSelectedAttributeValues) === JSON.stringify(this.selectedAttributeValues);
        },

        // When the user has a new variant selection, we then check if this selection is indeed a valid variant selection
        // so that we can show to the user that the selection is valid with some styling
        selectedAttributeValuesVariantExists(property = null)
        {
            let variant = this.productVariantsLocal.filter(variant => variant.shop_product_variant_attributes
                .map(variantAttribute => Object.values(this.selectedAttributeValues).includes(variantAttribute.value))
                .every(value => value)
            );

            if( property ) {
                return variant.length ? variant[0]?.[property] : null;
            }

            return variant.length;
        },

        initSelectedAttributeValues(selectValueString)
        {
            // Get product variant.
            let productVariant = _.find(this.productVariantsLocal, { id: this.currentProductVariantId });

            // Loop product attributes.
            for(let shopProductAttribute of this.shopProductAttributes)
            {
                // Get variant attribute.
                let productVariantAttribute = _.find(productVariant.shop_product_variant_attributes, { shop_product_attribute_id: shopProductAttribute.id });

                // TODO Low: Fix empty productVariantAttribute when this product variant is missing this attribute.
                // Set value of variant attribute as selected value?
                if(productVariantAttribute)
                    this.$set(this[selectValueString], shopProductAttribute.id, productVariantAttribute.value);
            }
        },

        filterProductVariants(skipShopProductAttribute = null)
        {
            // Get all product variants.
            let productVariants = [].concat(this.productVariantsLocal);

            // Filter on selection, but not the given product attribute.
            for(let [id, attributeValue] of Object.entries(this.selectedAttributeValues))
            {
                // Skip due to has no filter or is given product attribute?
                if(attributeValue === null || attributeValue === '' || (skipShopProductAttribute && skipShopProductAttribute.id == id))
                    continue;

                // Filter out selection.
                productVariants = _.filter(productVariants, productVariant =>
                {
                    let productVariantAttribute = _.find(productVariant.shop_product_variant_attributes, productVariantAttribute => productVariantAttribute.shop_product_attribute_id == id);

                    return productVariantAttribute && productVariantAttribute.value === attributeValue;
                });
            }

            //
            return productVariants;
        },

        // TODO Low: Refactor to computed property so we can loose the $forceUpdate in the <select.
        // TODO Low: Optimize, refactor.
        productVariantExistsForAttributeValueHelper(attributeValue, shopProductAttribute)
        {
            // Get all product variants.
            let productVariants = this.filterProductVariants(shopProductAttribute);

            // No product variants left?
            if(productVariants.length == 0)
                return false;

            // Filter on the given value.
            productVariants = _.filter(productVariants, productVariant =>
            {
                let productVariantAttribute = _.find(productVariant.shop_product_variant_attributes, productVariantAttribute => productVariantAttribute.shop_product_attribute_id == shopProductAttribute.id);

                return productVariantAttribute && productVariantAttribute.value === attributeValue;
            });

            // Has product variants left?
            return productVariants.length > 0;
        },

        manageUrl() {
            // Abort due to no product variant selected?
            if (!this.selectedProductVariant)
                return;

            // Construct new url.
            let newUrl = this.productVariantBaseUrl.replace(':shopProductVariantSlug', this.selectedProductVariant.slug['nl']);
            let queryParts = [];

            // Add filtered store?
            if (this.storeId)
                queryParts.push('store=' + this.storeId);

            // Add filtered discount?
            if (this.discountSlug)
                queryParts.push('actie=' + this.discountSlug);

            // Add url query parts?
            if (queryParts.length > 0)
                newUrl += (!newUrl.includes('?') ? '?' : '') + queryParts.join('&');

            // Navigate due to new url?
            if (newUrl != document.location.href) {
                document.location.href = newUrl;
            }
        }

    },

    watch: {

        'selectedProductVariant'(newVal)
        {
            // Navigate to new product variant?
            if(newVal) {
                this.manageUrl();

                // @ugly this is ugly but because price is not in this component we have to hide it if attributes are unavailable
                $('.possiblePrices').removeClass('hidden');
            } else {
                // @ugly this is ugly but because price is not in this component we have to hide it if attributes are unavailable
                $('.possiblePrices').addClass('hidden');
            }
        },

    },

    computed: {

        shopProductAttributes()
        {
            let attributeId2attribute = {};

            // Loop product variants.
            for(let productVariant of this.productVariantsLocal)
            {
                for(let productVariantAttribute of productVariant.shop_product_variant_attributes)
                {
                    // Get or make existing item.
                    let existingItem = attributeId2attribute[productVariantAttribute.shop_product_attribute.id];

                    if(!existingItem)
                        existingItem = attributeId2attribute[productVariantAttribute.shop_product_attribute.id] = {
                            attributeValues: [],
                            ...productVariantAttribute.shop_product_attribute
                        };

                    // Skip due to value already seen?
                    if(existingItem.attributeValues.indexOf(productVariantAttribute.value) !== -1)
                        continue;

                    // Add attribute value.
                    existingItem.attributeValues.push(productVariantAttribute.value);
                }
            }

            // Sort by attribute sequence.
            return _.sortBy(
                Object.values(attributeId2attribute),
                'sequence'
            );
        },

        //productVariantExistsForAttributeValue[shopProductAttribute.id].indexOf(attributeValue) === -1

        productVariantExistsForAttributeValue()
        {
            let result = {};

            // Loop product attributes.
            for(let shopProductAttribute of this.shopProductAttributes)
            {
                let attributeValuesExists = [];

                // Loop values.
                for(let attributeValue of shopProductAttribute.attributeValues)
                {
                    if(this.productVariantExistsForAttributeValueHelper(attributeValue, shopProductAttribute))
                        attributeValuesExists.push(attributeValue);
                }

                // Set
                result[shopProductAttribute.id] = attributeValuesExists;
            }

            //
            return result;
        },

        selectedProductVariant()
        {
            // Get filtered product variants.
            let productVariants = this.filterProductVariants();

            // Return only the one and only one.
            return productVariants.length == 1 ? productVariants[0] : null;
        },

    },

}

</script>
